export const __INFO = {
  version: 'WebGAL 4.5.7',
  contributors: [
    // 现在改为跳转到 GitHub 了
  ],
};
